<div class="flex flex-col service-setup h-100-percent">
  <app-sidenav-header [title]="(edit ? 'PATH_TO_LIVE.EDIT_PATH_TO_LIVE_WORKFLOW' : 'PATH_TO_LIVE.DEFINE_PATH_TO_LIVE_WORKFLOW') | transloco" 
    [subtitle]="'PATH_TO_LIVE.PATH_TO_LIVE' | transloco"></app-sidenav-header>

  <div class="form-field mb-0">
    <div class="flex flex-row mb-4" >
      <label class="fs-12">{{ 'PATH_TO_LIVE.ENVIRONMENTS' | transloco }}</label>
      <mat-icon svgIcon="info" [title]="'PATH_TO_LIVE.ENVIRONMENTS' | transloco" class="icon-sm ml-10" 
      matTooltipClass="right" matTooltipPosition="{{Constants.POSITION_RIGHT}}" [matTooltip]="('INSTANCE_SUMMARY.TOOLTIP.ENVIRONMENTS' | transloco)"></mat-icon>
    </div>
  </div>

  <div class="overflow-y-auto">
    <div *ngIf="pathToLiveTestForm" class="test-data-zone">
      <ng-container [ngTemplateOutlet]="pathToLiveForm"
        [ngTemplateOutletContext]="{
          offset: 0,
          title: 'PATH_TO_LIVE.TEST_DATA_ZONE' | transloco,
          pathToLiveForm: pathToLiveTestForm,
          dataZone: DataZone.DEVELOPMENT
        }">
      </ng-container>
    </div>

    <div *ngIf="pathToLivePiiForm" class="pii-data-zone">
      <ng-container [ngTemplateOutlet]="pathToLiveForm"
        [ngTemplateOutletContext]="{
          offset: testFormArray.length,
          title: 'PATH_TO_LIVE.PII_DATA_ZONE' | transloco,
          pathToLiveForm: pathToLivePiiForm,
          dataZone: DataZone.SECURE
        }">
      </ng-container>
    </div>
  </div>

  <span class="flex-auto"></span>
  <mat-divider class="mt-32 mb-32 neutral-2"></mat-divider>

  <div class="flex-row" dir="rtl">
    <button class="accent ml-16" type="button" (click)="saveWorkflow()" [ngClass]="{'disabled': isWorkflowEnabled}">{{ 'PATH_TO_LIVE.SAVE_WORKFLOW' | transloco }}</button> 
    <button class="white" type="button" (click)="sidenavService.closeRightSidenav()">
      {{ 'BUTTONS.CANCEL' | transloco }}
    </button>
  </div>
</div>

<ng-template #pathToLiveForm let-offset="offset" let-title="title"
  let-pathToLiveForm="pathToLiveForm" let-dataZone="dataZone"> 
  <div class="data-zone-header mat-small overline-font fs-12 pt-8 pb-8 pl-16 w-100-percent ta-left">
    {{ title }}
  </div>

  <div class="flex flex-col environment-form p-20 mb-10">
    <div *ngIf="dataZone !== DataZone.DEVELOPMENT" class="flex justify-center mb-20">
      <button class="flex justify-center rounded white" (click)="addToPiiDataZone()">
        <mat-icon svgIcon="add" class="icon-sm mr-8"></mat-icon>
        {{ 'PATH_TO_LIVE.ADD' | transloco }}
      </button>
    </div>

    <div class="flex">
      <div class="flex flex-col counter-column">
        <div *ngFor="let pathToLiveEnvironment of pathToLiveForm.controls.pathToLiveConfiguration.controls; let i = index"
          class="flex flex-col justify-center items-center">
          <div class="flex justify-center items-center number mat-headline-6">
            {{ offset + i + 1 }}
          </div>
          <div *ngIf="i < pathToLiveForm.controls.pathToLiveConfiguration.controls.length - 1" class="arrow-down"></div>
        </div>
      </div>

      <form [formGroup]="pathToLiveForm" class="felx-col basis-full">
        <div class="flex-col" class="environment-name" *ngFor="let pathToLiveEnvironment of pathToLiveForm.controls.pathToLiveConfiguration.controls; let i = index">
          <div class="flex flex-row justify-items-center items-center">
            <input #environmentName class="pr-44" [readonly]="pathToLiveEnvironment.controls.instanceId.value" [formControl]="pathToLiveEnvironment.controls.environment">

            <ng-container *ngIf="pathToLiveEnvironment.controls.editable.value">
              <div class="icons h-24">
                <mat-icon *ngIf="!pathToLiveEnvironment.controls.instanceId.value" svgIcon="close" (click)="deleteEnvironment(pathToLiveForm, i)"></mat-icon>
                <mat-icon *ngIf="pathToLiveEnvironment.controls.instanceId.value" svgIcon="lock" [title]="'PATH_TO_LIVE.TERMINATE_INSTANCE_BEFORE_REMOVE' | transloco"></mat-icon>
              </div>
            </ng-container>
          </div>

          <app-error [control]="pathToLiveEnvironment.get('environment')"></app-error>

        </div>
      </form>
    </div>

    <div *ngIf="dataZone === DataZone.DEVELOPMENT" class="flex justify-center mt-20">
      <button class="flex justify-center rounded white" (click)="addToTestDataZone()">
        <mat-icon svgIcon="add" class="icon-sm mr-8"></mat-icon>
        {{ 'PATH_TO_LIVE.ADD' | transloco }}
      </button>
    </div>
  </div>
</ng-template>
